import React from 'react'
import PropTypes from 'prop-types'
import { Alert, Form, Input, Modal } from 'antd'
import { withTranslation } from 'react-i18next'

const CancelDocumentModal = ({
    documentNo,
    i18n,
    onCancel,
    onSubmit,
    saving,
    title,
    visible
}) => {
    const [form] = Form.useForm()

    const handleOk = () => {
        form.validateFields().then(({ reason }) => {
            onSubmit(reason)
            form.resetFields()
        })
    }

    const handleCancel = () => {
        form.resetFields()
        onCancel()
    }

    return (
        <Modal
            confirmLoading={saving}
            okButtonProps={{ danger: true }}
            okText={i18n.t('confirms:invoice.cancelDocument')}
            onCancel={handleCancel}
            onOk={handleOk}
            open={visible}
            title={title}>
            <Alert
                description={i18n.t('confirms:invoice.cancelWarning')}
                message={documentNo}
                showIcon
                style={{ marginBottom: 16 }}
                type='warning'
            />
            <Form form={form} layout='vertical'>
                <Form.Item
                    label={i18n.t('confirms:invoice.cancelReason')}
                    name='reason'
                    rules={[
                        {
                            required: true,
                            message: i18n.t(
                                'confirms:invoice.cancelReasonRequired'
                            )
                        }
                    ]}>
                    <Input.TextArea autoFocus rows={3} />
                </Form.Item>
            </Form>
        </Modal>
    )
}

CancelDocumentModal.propTypes = {
    documentNo: PropTypes.string,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    saving: PropTypes.bool,
    title: PropTypes.string,
    visible: PropTypes.bool
}

export default withTranslation('confirms')(CancelDocumentModal)
